const PAYMENTS_TRANSITION = 'travelKe/confirmPayments/transition/';
export const INITIALIZE_PAYMENTS = 'travelKe/confirmPayments/initialize/';

// Transitions
export const FORM_VALIDATE_TRANSITION_PAYMENTS = PAYMENTS_TRANSITION + 'validateForm';
export const FORM_INVALIDATE_TRANSITION_PAYMENTS = PAYMENTS_TRANSITION + 'invalidateForm';
export const validateForm = () => ({ type: FORM_VALIDATE_TRANSITION_PAYMENTS });
export const invalidateForm = () => ({ type: FORM_INVALIDATE_TRANSITION_PAYMENTS });

// Events
export const PAYMENTS_SET_VALUE = 'travelKe/payments/setValue/';
export const PAYMENTS_SET_VALID = 'travelKe/payments/setValid/';
export const KE_PAYMENTS_SET_VALUE = 'travelKe/ke/payments/setValue/';

// API Call actions STK PUSH
export const TRIGGER_PAYMENTS_STK_PUSH = PAYMENTS_SET_VALUE + 'triggerPaymentsStkPush';
export const TRIGGER_KE_PAYMENTS_STK_PUSH = KE_PAYMENTS_SET_VALUE + 'triggerPaymentsStkPush';
export const TRIGGER_PAYMENTS_STK_PUSH_SUCCESS = PAYMENTS_SET_VALUE + 'triggerPaymentsStkPushSuccess';
export const TRIGGER_PAYMENTS_STK_PUSH_FAILURE = PAYMENTS_SET_VALUE + 'triggerPaymentsStkPushFailure';
export const API_PENDING_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/pending`;
export const API_SUCCESS_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/success`;
export const API_FAILURE_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/push/failure`;
export const API_INITIALIZE_TRANSITION_PAYMENTS_PUSH = `${PAYMENTS_SET_VALUE}/apiTransition/initialize`;

export const API_PENDING_MPESA_CONFIRMATION = PAYMENTS_SET_VALUE + 'apiTransition/mpesaConfirmation/pending';
export const API_SUCCESS_MPESA_CONFIRMATION = PAYMENTS_SET_VALUE + 'apiTransition/mpesaConfirmation/success';
export const API_FAILURE_MPESA_CONFIRMATION = PAYMENTS_SET_VALUE + 'apiTransition/mpesaConfirmation/failure';
export const API_INITIALIZE_MPESA_CONFIRMATION = PAYMENTS_SET_VALUE + 'apiTransition/mpesaConfirmation/initialize';
export const INITIALIZE_MPESA = 'travelKe/mpesaConfirmation/initialize';
export const SET_MPESA_CONFIRMATION_DATA = PAYMENTS_SET_VALUE + 'mpesaConfirmationData';
export const TRIGGER_MPESA_CONFIRMATION = PAYMENTS_SET_VALUE + 'triggerMpesaConfirmation';

export const TRIGGER_BANK_DETAILS = PAYMENTS_SET_VALUE + 'bank/Details';
export const BANK_DETAILS_SUCCESS = PAYMENTS_SET_VALUE + 'bank/Details/success';
export const BANK_DETAILS_FAILURE = PAYMENTS_SET_VALUE + 'bank/Details/failure';

export const API_BANK_DETAILS_SUCCESS = PAYMENTS_SET_VALUE + '/api/bank/Details/success';
export const API_BANK_DETAILS_FAILURE = PAYMENTS_SET_VALUE + '/api/bank/Details/failure';
export const API_BANK_DETAILS_PENDING = PAYMENTS_SET_VALUE + '/api/bank/Details/pending';

export const apiTransitionStkPush = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PAYMENTS_PUSH,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PAYMENTS_PUSH,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PAYMENTS_PUSH,
    }),
    initialize: () => ({
        type: API_INITIALIZE_TRANSITION_PAYMENTS_PUSH,
    }),
};

export const apiTransitionBankDetails = {
    pending: () => ({
        type: API_BANK_DETAILS_PENDING,
    }),
    success: () => ({
        type: API_BANK_DETAILS_SUCCESS,
    }),
    failure: () => ({
        type: API_BANK_DETAILS_FAILURE,
    }),
};

export const mpesaConfirmationDetails = {
    pending: () => ({
        type: API_PENDING_MPESA_CONFIRMATION,
    }),
    success: () => ({
        type: API_SUCCESS_MPESA_CONFIRMATION,
    }),
    failure: () => ({
        type: API_FAILURE_MPESA_CONFIRMATION,
    }),
    initialize: () => ({
        type: API_INITIALIZE_MPESA_CONFIRMATION,
    }),
};

// API Call actions FLEX PAY status
export const CHECK_PAYMENTS_STATUS = PAYMENTS_SET_VALUE + 'checkPaymentsStatus';
export const CHECK_PAYMENTS_STATUS_SUCCESS = PAYMENTS_SET_VALUE + 'checkPaymentsStatusSuccess';
export const CHECK_PAYMENTS_STATUS_FAILURE = PAYMENTS_SET_VALUE + 'checkPaymentsStatusFailure';
export const API_PENDING_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/pending`;
export const API_SUCCESS_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/success`;
export const API_FAILURE_TRANSITION_PAYMENTS_STATUS = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/failure`;
export const API_FAILURE_TRANSITION_PAYMENTS_STATUS_INITIAL = `${PAYMENTS_SET_VALUE}/apiTransition/flex-pay/status/initial`;

export const apiTransitionPaymentsStatus = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PAYMENTS_STATUS,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PAYMENTS_STATUS,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PAYMENTS_STATUS,
    }),
    initialize: () => ({
        type: API_FAILURE_TRANSITION_PAYMENTS_STATUS_INITIAL,
    }),
};

export const transitionPaymentsForm = {
    formValid: () => ({
        type: FORM_VALIDATE_TRANSITION_PAYMENTS,
    }),
    formInvalid: () => ({
        type: FORM_INVALIDATE_TRANSITION_PAYMENTS,
    }),
};

// Form input  actions
export const PHONE_NUMBER_SET_VALUE = PAYMENTS_SET_VALUE + 'phoneNumber';
export const PHONE_NUMBER_SET_VALID = PAYMENTS_SET_VALID + 'phoneNumber';
export const TERMS_SET_VALUE = PAYMENTS_SET_VALUE + 'terms';
export const TERMS_SET_VALID = PAYMENTS_SET_VALID + 'terms';
export const SET_NETWORK_PROVIDER = PAYMENTS_SET_VALUE + 'networkProvider';
export const SET_NETWORK_PROVIDER_VALID = PAYMENTS_SET_VALID + 'networkProvider';
export const setPhoneNumberValue = (value) => ({ type: PHONE_NUMBER_SET_VALUE, value });
export const setPhoneNumberValid = (error) => ({ type: PHONE_NUMBER_SET_VALID, error });
export const setTermsValue = (value) => ({ type: TERMS_SET_VALUE, value });
export const setTermsValid = (error) => ({ type: TERMS_SET_VALID, error });
export const setNetworkProviderValue = (value) => ({ type: SET_NETWORK_PROVIDER, value });
export const setNetworkProviderValid = (error) => ({ type: SET_NETWORK_PROVIDER_VALID, error });

export const MPESA_TRANSACTION_CODE_SET_VALUE = PAYMENTS_SET_VALUE + 'mpesaTransactionCode';
export const MPESA_TRANSACTION_CODE_SET_VALID = PAYMENTS_SET_VALID + 'mpesaTransactionCode';
export const setMpesaTransactionCodeValue = (value) => ({ type: MPESA_TRANSACTION_CODE_SET_VALUE, value });
export const setMpesaTransactionCodeValid = (error) => ({ type: MPESA_TRANSACTION_CODE_SET_VALID, error });
export const initializeMpesa = () => ({ type: INITIALIZE_MPESA });

// API actions triggers
export const triggerPaymentsStkPush = () => ({ type: TRIGGER_PAYMENTS_STK_PUSH });
export const triggerKePaymentsStkPush = () => ({ type: TRIGGER_KE_PAYMENTS_STK_PUSH });
export const triggerPaymentsStkPushSuccess = (value) => ({ type: TRIGGER_PAYMENTS_STK_PUSH_SUCCESS, value });
export const triggerPaymentsStkPushFailure = (error) => ({ type: TRIGGER_PAYMENTS_STK_PUSH_FAILURE, error });
export const checkPaymentsStatusSuccess = (value) => ({ type: CHECK_PAYMENTS_STATUS_SUCCESS, value });
export const checkPaymentsStatusFailure = (error) => ({ type: CHECK_PAYMENTS_STATUS_FAILURE, error });
export const initializePayments = () => ({ type: INITIALIZE_PAYMENTS });
export const checkPaymentsStatus = () => ({ type: CHECK_PAYMENTS_STATUS });
export const triggerMpesaConfirmation = () => ({ type: TRIGGER_MPESA_CONFIRMATION });

export const triggerBankDetails = () => ({ type: TRIGGER_BANK_DETAILS });
export const bankDetailsSuccess = (value) => ({ type: BANK_DETAILS_SUCCESS, value });
export const bankDetailsFailure = (error) => ({ type: BANK_DETAILS_FAILURE, error });

export const setMpesaConfirmationData = (value) => ({ type: SET_MPESA_CONFIRMATION_DATA, value });
